import benchmark_create from "$root/assets/images/create-dialog[preload]/benchmark-create.svg";
import benchmark_template from "$root/assets/images/create-dialog[preload]/benchmark-template.svg";
import { typedUrlForRoute } from "$root/components/PlatformRouter/RoutesDef";
import { ManualCreationEntitiesEnum } from "$root/pages/ManualCreation/common";
import type { SpawnResult } from "@mdotm/shadcn/legacy/react-extensions";
import { spawnMultipleChoiceCreationDialog } from "./MultipleChoiceCreationDialog";

export function spawnReferenceCreationDialog({ intentId }: { intentId?: string }): SpawnResult<void> {
	return spawnMultipleChoiceCreationDialog({
		options: [
			{
				href: typedUrlForRoute("Portfolios/ManualCreation", {
					entity: ManualCreationEntitiesEnum.Reference,
					intentId,
				}),
				"data-qualifier": "PortfolioStudio/ReferenceList/NewReference/Scratch",
				icon: benchmark_create,
				title: "Create",
				description: "Select instruments and set weights.",
			},
			{
				href: typedUrlForRoute("Portfolios/ManualCreation", {
					entity: ManualCreationEntitiesEnum.Reference,
					copyComposition: "true",
					intentId,
				}),
				"data-qualifier": "PortfolioStudio/ReferenceList/NewReference/FromTemplate",
				icon: benchmark_template,
				title: "Select template",
				description: "Start from an existing template.",
			},
		],
	});
}
